import { TimeSelect } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceTimeSelect",
  //extends: TimeSelect,
  mixins: [TimeSelect, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    pickerDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
